import { render, staticRenderFns } from "./AdminFeedbackSettings.vue?vue&type=template&id=dbbfdad8&scoped=true&"
import script from "./AdminFeedbackSettings.vue?vue&type=script&lang=js&"
export * from "./AdminFeedbackSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminFeedbackSettings.vue?vue&type=style&index=0&id=dbbfdad8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbfdad8",
  null
  
)

export default component.exports